import { render, staticRenderFns } from "./LettersDashParent.vue?vue&type=template&id=0f0f6668&scoped=true&"
import script from "./LettersDashParent.vue?vue&type=script&lang=js&"
export * from "./LettersDashParent.vue?vue&type=script&lang=js&"
import style0 from "./LettersDashParent.vue?vue&type=style&index=0&id=0f0f6668&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f0f6668",
  null
  
)

export default component.exports